<template>
  <div>
    <h4>
      {{ $t('Workload And Shortage') }}
    </h4>
    <v-row>
      <v-col lg="6">
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="shortageTableHeaders"
              :items="shortageData || []"
              calculate-widths
              show-expand
              item-key="reason"
            >
              <template v-slot:top>
                <div class="d-flex">
                  <v-btn
                    class="ml-auto"
                    color="secondary"
                    @click="exportReasonTable"
                  >
                    {{ $t('export') }}
                  </v-btn>
                </div>
              </template>


              <template v-slot:expanded-item="{ headers, item }">
                <td
                  class="pa-2"
                  :colspan="headers.length"
                >
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            {{ $t('Laboratory') }}
                          </th>
                          <th class="text-left">
                            {{ $t('Manager') }}
                          </th>
                          <th class="text-left">
                            {{ $t('Address') }}
                          </th>
                          <th class="text-left">
                            {{ $t('Telephone') }}
                          </th>

                          <th class="text-left" />
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="i in item.wkItems"
                          :key="i.laboratory.id + item.reason"
                        >
                          <td>{{ i.laboratory.name }}</td>

                          <td>
                            <span v-if="i.laboratory.manager">
                              {{ i.laboratory.manager.firstName }} {{ i.laboratory.manager.lastName }}
                            </span>
                          </td>
                          <td>{{ i.laboratory.address }}</td>
                          <td>{{ i.laboratory.telephone }}</td>

                          <td>
                            <v-btn
                              icon
                              :to="{name: 'LaboratoryView', params: {laboratoryId: i.laboratory.id}}"
                              target="_blank"
                            >
                              <v-icon
                                small
                              >
                                mdi-open-in-new
                              </v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="6">
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="analysisPerformedTableHeaders"
              :items="analysisPerformedData || []"
              calculate-widths
            >
              <template v-slot:top>
                <div class="d-flex">
                  <v-btn
                    class="ml-auto"
                    color="secondary"
                    @click="exportAnalysisTable"
                  >
                    {{ $t('export') }}
                  </v-btn>
                </div>
              </template>

              <template
                v-slot:item.analysis="{ item }"
              >
                <div>
                  <template v-if="item.analysis.name">
                    {{ item.analysis.category }} <span class="mx-1">»</span>
                    {{ item.analysis.group }} <span class="mx-1">»</span>
                    {{ item.analysis.name }}
                  </template>
                </div>
              </template>

              <!--          <template v-slot:top>-->
              <!--            <div class="d-flex">-->
              <!--              <v-btn-->
              <!--                class="ml-auto"-->
              <!--                color="secondary"-->
              <!--                @click="exportAverageTable"-->
              <!--              >-->
              <!--                export-->
              <!--              </v-btn>-->
              <!--            </div>-->
              <!--          </template>-->
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
    import moment from 'moment'
    import {export_json_to_excel_custom} from "@/vendor/Export2Excel";

    export default {
        name: "WorkloadDashboardStatistics",
        props: {
            workloadData: {
                type: Array,
                required: true,
            },
        },

        data: () => {
            return {}
        },

        computed: {
            shortageTableHeaders() {
                return [
                    {
                        text: this.$t('Reason'),
                        value: 'reason',
                        align: 'start',
                        sortable: false,
                    },
                    {
                        text: this.$t('Count'),
                        value: 'wkItems.length',
                        align: 'start',
                        sortable: false,
                    },
                    {
                        text: '',
                        value: 'data-table-expand'
                    },
                ]
            },
            shortageData() {
                let shortageReasonGroup = {};
                this.filteredCurrentYearData?.forEach(wk => {
                    wk.info?.forEach(i => {
                        if (i.reason) {
                            if (!shortageReasonGroup[i.reason]) {
                                shortageReasonGroup[i.reason] = {reason: i.reason, wkItems: []}
                            }
                            shortageReasonGroup[i.reason].wkItems.push(wk)
                        }

                    })
                });

                let data = Object.values(shortageReasonGroup);
                data.forEach(e => {
                    e.wkItems = Object.values(
                        e.wkItems.reduce((r, a) => {
                            if (!r[a.laboratory.id]) {
                                r[a.laboratory.id] = {}
                            }
                            r[a.laboratory.id].laboratory = a.laboratory;
                            r[a.laboratory.id].item = [...r[a.laboratory.id].item || [], a];
                            return r;
                        }, {})
                    )
                });

                return data
            },

            analysisPerformedTableHeaders() {
                return [
                    {
                        text: this.$t('Analysis'),
                        value: 'analysis',
                        align: 'start',
                        sortable: false,
                    },
                    {
                        text: this.$t('Number Performed'),
                        value: 'numberPerformed',
                        align: 'start',
                        sortable: false,
                    },
                    // {
                    //     text: '',
                    //     value: 'data-table-expand'
                    // },
                ]
            },

            analysisPerformedData() {
                let analysisGroup = {};
                this.filteredCurrentYearData?.forEach(wk => {
                    wk.info?.forEach(i => {
                        if (i.numberPerformed) {
                            let key = `${i.analysis.category}-${i.analysis.group}=${i.analysis.name}`;
                            if (!analysisGroup[key]) {
                                analysisGroup[key] = {analysis: i.analysis, wkItems: [], numberPerformed: 0}
                            }
                            analysisGroup[key].wkItems.push(wk);
                            analysisGroup[key].numberPerformed += parseInt(i.numberPerformed) || 0
                        }

                    })
                });

                let data = Object.values(analysisGroup);
                data.forEach(e => {
                    e.wkItems = Object.values(
                        e.wkItems.reduce((r, a) => {
                            if (!r[a.laboratory.id]) {
                                r[a.laboratory.id] = {}
                            }
                            r[a.laboratory.id].laboratory = a.laboratory;
                            r[a.laboratory.id].item = [...r[a.laboratory.id].item || [], a];
                            return r;
                        }, {})
                    )
                });

                return data
            },

            filteredCurrentYearData() {
                let currentYear = moment().year();
                return this.workloadData.filter(wk => moment(wk.date).year() === currentYear);
            }
        },

        methods: {
          exportReasonTable() {
            let multiData = [];

            {
              const tHeader = [
                '#', 'Reason', 'Count'
              ];


              const filterVal = [
                '#', 'reason', 'wkItems'
              ];


              const deepValues = {
                wkItems(item) {
                  return item?.wkItems?.length || 0
                }
              };

              const data = this.shortageData.map((v, index) => {
                return filterVal.map(j => {
                  if (j === '#') return index + 1;
                  if (j in deepValues) {
                    return deepValues[j](v)
                  } else {
                    return v[j].toString()
                  }
                });
              }).filter(e => e);

              multiData.push({name: 'Shortage', header: tHeader, data})
            }

            {
              const tHeader = [
                '#', 'Id', 'Name', 'Address', 'Manager', 'Telephone'
              ];


              const filterVal = [
                '#', 'id', 'name', 'address', 'manager', 'telephone'
              ];

              const deepValues = {
                manager(item) {
                  return item?.manager?.firstName + '' + item?.manager?.lastName || ''
                }
              };

              for (let s of this.shortageData) {
                console.log("s: ", s);
                const data = s.wkItems.map((v, index) => {
                  return filterVal.map(j => {
                    if (j === '#') return index + 1;
                    if (v.laboratory[j]) {
                      if (j in deepValues) {
                        return deepValues[j](v.laboratory)
                      } else {
                        return v.laboratory[j].toString()
                      }
                    }
                    return ''
                  });
                }).filter(e => e);

                let name = s.reason.length > 30 ? s.reason.substring(0, 20) + '...' : s.reason;

                multiData.push({name: name, header: tHeader, data})

              }
            }

            export_json_to_excel_custom({
              multiData,
              filename: 'shortage',
              autoWidth: true,
            })

          },

          exportAnalysisTable() {
            let multiData = [];

            {
              const tHeader = [
                '#', 'Analysis', 'Number Performed'
              ];


              const filterVal = [
                '#', 'analysis', 'numberPerformed'
              ];


              const deepValues = {
                analysis(item) {
                  if(!item.analysis) return ''
                  return `${item.analysis.category} » ${item.analysis.group} » ${item.analysis.name}`
                }
              };

              const data = this.analysisPerformedData.map((v, index) => {
                return filterVal.map(j => {
                  if (j === '#') return index + 1;
                  if (j in deepValues) {
                    return deepValues[j](v)
                  } else {
                    return v[j].toString()
                  }
                });
              }).filter(e => e);

              multiData.push({name: 'Shortage', header: tHeader, data})
            }

            export_json_to_excel_custom({
              multiData,
              filename: 'shortage',
              autoWidth: true,
            })

          },

        }
    }
</script>

<style scoped>

</style>
